/**
 * Handheld / touch play gets the static-wave surf game instead of
 * the keyboard side-scroller. Force either way from the URL:
 *   /mild-concern/?surf=1   → always surf
 *   /mild-concern/?surf=0   → always the desktop game
 */

export function wantsSurfGame() {
  try {
    const v = new URL(location.href).searchParams.get('surf');
    if (v === '1' || v === 'true') return true;
    if (v === '0' || v === 'false') return false;
  } catch { /* ignore */ }

  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(pointer: coarse)').matches
    || window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
